
define('text!templates/modules/feedback/blocks/app-rating.html',[],function () { return '<div id="feedback-app-rating"></div>';});

